// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".community-page__menu[data-v-0ca64138]{vertical-align:top;font-size:18px}.community-page__content[data-v-0ca64138]{vertical-align:top;font-size:18px}.community-page__container[data-v-0ca64138]{font-size:0}\n", ""]);
// Exports
module.exports = exports;
